/** Shared scroll-reveal — same pattern as Sustainability section */

export const aboutScrollViewport = {
  once: true,
  amount: 0.18,
  margin: '0px 0px -6% 0px',
};

/** Parent: triggers staggered children on scroll */
export const scrollStagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12, delayChildren: 0.06 },
  },
};

/** Nested list (timeline steps, metric cards, mfg tiles) */
export const scrollChildStagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.1, delayChildren: 0.04 },
  },
};

/** Each block: fade up + slight scale (greener tomorrow style) */
export const scrollItem = {
  hidden: { opacity: 0, y: 40, scale: 0.97 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

export const scrollItemReduced = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.35 } },
};
